import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.9404 15.6464L6.14755 9.85355C5.83256 9.53857 6.05565 9 6.5011 9L18.0869 9C18.5323 9 18.7554 9.53857 18.4404 9.85355L12.6475 15.6464C12.4523 15.8417 12.1357 15.8417 11.9404 15.6464Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgTriangleDown;
